import React, { Fragment } from "react";
import { Card, Col, Row } from "react-bootstrap";

import { HorizontalDivider } from "../../../common/components/core";
import { PaymentReceiptState } from "../../../types/payment";
import { formatAmount } from "../../../utils/amount";
import { formatToDate } from "../../../utils/common";

type ReceiptDetailProps = {
    receipt: PaymentReceiptState;
};

const ReceiptDetail = ({ receipt }: ReceiptDetailProps): JSX.Element => {
    return (
        <Card.Body className="p-0 mb-3 border-0">
            <dl>
                <div>
                    <dd className="mb-2">
                        <span className="h1">
                            {formatAmount(receipt.amountMinor)}
                        </span>
                        <span className="ms-2 fw-bold">
                            {receipt.currency}
                        </span>
                    </dd>
                    <dt className="text-label-grey mb-3">Amount</dt>
                </div>
                <HorizontalDivider />
                <Row xs={4}>
                    <Col className="border-end border-humble-grey">
                        <dt className="mt-2 mb-2 text-label-grey">
                            Transaction Date
                        </dt>
                        <dd className="fw-bold">{formatToDate(receipt.entryDate)}</dd>
                    </Col>
                    <Col className="px-4">
                        <dt className="mt-2 mb-2 text-label-grey">
                            Related Reference Number
                        </dt>
                        <dd className="text-pre-wrap fw-bold">
                            {receipt.relatedReference}
                        </dd>
                    </Col>
                </Row>
                <HorizontalDivider />

                <dt className="text-label-grey mt-3 mb-2">
                    Ordering Customer (Optional)
                </dt>
                <dd className="text-pre-wrap fw-bold mb-5">
                    {receipt.orderingCustomer}
                </dd>

                <dt className="text-label-grey mb-2">
                    Ordering Institution (Optional)
                </dt>
                <dd className="text-pre-wrap fw-bold mb-5">
                    {receipt.orderingInstitution}
                </dd>

                <dt className="text-label-grey mb-2">Remittance Information</dt>
                <dd className="text-pre-wrap fw-bold">
                    {
                    receipt.remittanceInformation.narratives.map((it, index) => (
                        <Fragment key={index}>
                            {it}
                            <br />
                        </Fragment>
                    ))
                    }
                </dd>
            </dl>
        </Card.Body>
    );
};

export default ReceiptDetail;
